import React, { useEffect } from 'react';
import { isEqual, noop } from 'lodash';
import { Loading, MultiColumnList, Row } from '@folio/stripes/components';
import { listTableMapping } from './helpers/mappers';
import { listTableResultFormatter } from './helpers/formatters';
import { LISTS_VISIBLE_COLUMNS } from '../../constants';
import { useLists, useListsIdsToTrack, usePrevious, useListsPagination } from '../../hooks';
import { columnWidthsConfig } from './configs';
import css from './ListsTable.module.css';
export var ListsTable = function (_a) {
    var activeFilters = _a.activeFilters, _b = _a.setTotalRecords, setTotalRecords = _b === void 0 ? noop : _b;
    var _c = useListsPagination({}), gotToFirstPage = _c.gotToFirstPage, goToLastPage = _c.goToLastPage, pagination = _c.pagination, checkHasNextPage = _c.checkHasNextPage, hasPreviousPage = _c.hasPreviousPage, onNeedMoreData = _c.onNeedMoreData;
    var _d = useListsIdsToTrack(), updatedListsData = _d.updatedListsData, setRecordIds = _d.setRecordIds;
    var prevActiveFilters = usePrevious(activeFilters);
    useEffect(function () {
        if (prevActiveFilters && !isEqual(prevActiveFilters, activeFilters)) {
            gotToFirstPage();
            setRecordIds([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilters]);
    var _e = useLists({
        filters: activeFilters,
        size: pagination === null || pagination === void 0 ? void 0 : pagination.limit,
        offset: pagination === null || pagination === void 0 ? void 0 : pagination.offset
    }), listsData = _e.listsData, isLoading = _e.isLoading;
    useEffect(function () {
        var _a;
        if (isLoading) {
            return;
        }
        if ((_a = listsData === null || listsData === void 0 ? void 0 : listsData.content) === null || _a === void 0 ? void 0 : _a.length) {
            setRecordIds(listsData === null || listsData === void 0 ? void 0 : listsData.content.map(function (_a) {
                var id = _a.id;
                return id;
            }));
        }
        else if (listsData === null || listsData === void 0 ? void 0 : listsData.totalPages) {
            goToLastPage(listsData === null || listsData === void 0 ? void 0 : listsData.totalPages);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listsData]);
    var onNeedMoreDataHandler = function (askAmount, limit, index, direction) {
        if (direction === void 0) { direction = ''; }
        onNeedMoreData(direction);
        setRecordIds([]);
    };
    if (isLoading) {
        return (React.createElement(Row, { center: "xs" },
            React.createElement(Loading, { size: "large" })));
    }
    var _f = listsData !== null && listsData !== void 0 ? listsData : {}, _g = _f.totalRecords, totalRecords = _g === void 0 ? 0 : _g, totalPages = _f.totalPages;
    var content = (listsData !== null && listsData !== void 0 ? listsData : {}).content;
    if (updatedListsData === null || updatedListsData === void 0 ? void 0 : updatedListsData.content) {
        content = updatedListsData.content;
    }
    setTotalRecords(totalRecords);
    return (React.createElement(MultiColumnList, { autosize: true, interactive: true, "data-testid": "ItemsList", contentData: content !== null && content !== void 0 ? content : [], headerRowClass: css.listTableHeaderSticky, columnWidths: columnWidthsConfig, pagingType: 'prev-next', visibleColumns: LISTS_VISIBLE_COLUMNS, formatter: listTableResultFormatter, pageAmount: totalPages, totalCount: totalRecords, 
        // @ts-ignore:next-line
        pagingOffset: pagination.offset, pagingCanGoPrevious: hasPreviousPage && !isLoading, pagingCanGoNext: checkHasNextPage(totalRecords) && !isLoading, columnMapping: listTableMapping, onNeedMoreData: onNeedMoreDataHandler }));
};
